/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


// import firebase from 'firebase/app'
// import 'firebase/auth'
import router from '@/router'
import {api} from '../../utils/requests.js';

export default {
    loginAttempt({ dispatch }, payload) {

        // New payload for login action
        const newPayload = {
            userDetails: payload.userDetails,
            notify: payload.notify,
            closeAnimation: payload.closeAnimation,
            field_errors: payload.field_errors,
            instance: payload.instance
        }

        return dispatch('login', newPayload);

    },
    updateRole({commit}, payload) {
        // console.log("Updating Role")
        commit('UPDATE_AUTHENTICATED_ROLE', payload.role);
        if(payload.instance)
            payload.instance.$acl.change(payload.role)
    },
    login({ commit, state, dispatch }, payload) {

        // If user is already logged in notify and exit
        if (state.isUserLoggedIn()) {
            // Close animation if passed as payload
            if(payload.closeAnimation) payload.closeAnimation()

            payload.notify({
                title: 'Wierd',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });

            router.push(router.currentRoute.query.to || '/');
            return
        }
        
        return api.login({
            email: payload.userDetails.email, 
            password: payload.userDetails.password,
            handler_params: {instance: payload.instance}
        }).then((result) => {
            let res = result

            if(payload.closeAnimation) payload.closeAnimation()

            commit('UPDATE_AUTHENTICATED_USER', res)
            payload.instance.$acl.change(res.role)
            router.push(router.currentRoute.query.to || '/');
            return
        }, (err) => {

            if(payload.closeAnimation) payload.closeAnimation()

            if(err instanceof api.errors.network){
                payload.notify({
                    time: 2500,
                    title: 'Network Error',
                    text: "We're having trouble communicating with server, please retry in a minute.",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } else if(err instanceof api.errors.access_forbidden || err instanceof api.errors.unauthorized) {
                payload.notify({
                    time: 2500,
                    title: 'Oops',
                    text: "We're having trouble processing your request right now, please retry in a minute.",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } else {
                if(!err.status){
                    if(err.error){
                        payload.field_errors(err.error);
                    }
                    if(err.err_msg)
                        payload.notify({
                            time: 2500,
                            title: 'Error',
                            text: err.err_msg,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        });
                }else {
                    payload.notify({
                        time: 2500,
                        title: 'Wierd Stuff',
                        text: "This shouldn't have happened :/",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
            }
        });
    },

    // Google Login
    loginWithGoogle({commit, state}, payload) {
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
            return false
        }
        // const provider = new firebase.auth.GoogleAuthProvider();

        // firebase.auth().signInWithPopup(provider)
        //     .then((result) => {
        //         router.push(router.currentRoute.query.to || '/');
        //         commit('UPDATE_AUTHENTICATED_USER', result.user.providerData[0])
        //     }).catch((err) => {
        //         payload.notify({
        //             time: 2500,
        //             title: 'Error',
        //             text: err.message,
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'danger'
        //         });
        //     })
        // firebase.auth().onAuthStateChanged(function(user) {
        //     if (user) {
        //         user.updateProfile({
        //             roles: ['admin'],
        //         }).then(function() {
        //             this.$vs.notify({
        //                 title: 'Success',
        //                 text: "done",
        //                 iconPack: 'feather',
        //                 icon: 'icon-check',
        //                 color: 'success'
        //             });
        //         }, function(error) {
        //             this.$vs.notify({
        //                 title: 'Error',
        //                 text: error.message,
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //                 color: 'danger'
        //             });
        //         });

        //     }
        // });
    },

    // Facebook Login
    loginWithFacebook({commit, state}, payload) {
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
            return false
        }
        // const provider = new firebase.auth.FacebookAuthProvider();

        // firebase.auth().signInWithPopup(provider)
        //     .then((result) => {
        //         router.push(router.currentRoute.query.to || '/');
        //         commit('UPDATE_AUTHENTICATED_USER', result.user.providerData[0])
        //     }).catch((err) => {
        //         payload.notify({
        //             time: 2500,
        //             title: 'Error',
        //             text: err.message,
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'danger'
        //         });
        //     })
    },

    // Twitter Login
    loginWithTwitter({commit, state}, payload) {
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
            return false
        }
        // const provider = new firebase.auth.TwitterAuthProvider();

        // firebase.auth().signInWithPopup(provider)
        //     .then((result) => {
        //         router.push(router.currentRoute.query.to || '/');
        //         commit('UPDATE_AUTHENTICATED_USER', result.user.providerData[0])
        //     }).catch((err) => {
        //         payload.notify({
        //             time: 2500,
        //             title: 'Error',
        //             text: err.message,
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'danger'
        //         });
        //     })
    },

    // Github Login
    loginWithGithub({commit, state}, payload) {
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
            return false
        }
        // const provider = new firebase.auth.GithubAuthProvider();

        // firebase.auth().signInWithPopup(provider)
        //     .then((result) => {
        //         router.push(router.currentRoute.query.to || '/');
        //         commit('UPDATE_AUTHENTICATED_USER', result.user.providerData[0])
        //     }).catch((err) => {
        //         payload.notify({
        //             time: 2500,
        //             title: 'Error',
        //             text: err.message,
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'danger'
        //         });
        //     })
    },
    registerUser({dispatch}, payload) {

        // create user using firebase
        // firebase.auth().createUserWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)
        //     .then(() => {
        //         payload.notify({
        //             title: 'Account Created',
        //             text: 'You are successfully registered!',
        //             iconPack: 'feather',
        //             icon: 'icon-check',
        //             color: 'success'
        //         });

        //         const newPayload = {
        //             userDetails: payload.userDetails,
        //             notify: payload.notify,
        //             updateUsername: true
        //         }
        //         dispatch('login', newPayload)
        //     }, (error) => {
        //         payload.notify({
        //             title: 'Error',
        //             text: error.message,
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'danger'
        //         });
        //     })
    },
    updateUsername({ commit }, payload) {
        payload.user.updateProfile({
            displayName: payload.username
        }).then(() => {

            // If username update is success
              // update in localstorage
            let newUserData = Object.assign({}, payload.user.providerData[0])
            newUserData.displayName = payload.username
            commit('UPDATE_AUTHENTICATED_USER', newUserData)

            // If reload is required to get fresh data after update
              // Reload current page
            if(payload.isReloadRequired) {
                router.push(router.currentRoute.query.to || '/')
            }
        }).catch((err) => {
              payload.notify({
                time: 8800,
                title: 'Error',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        })
    },
    updateAuthenticatedUser({ commit, state, dispatch }, payload) {
        commit('UPDATE_AUTHENTICATED_USER', payload)        
        // dispatch('updateRole', {role: payload.role})
        // acl.change(localStorage.getItem('userRole'))
    },
    logout({commit}){
        commit('LOGOUT_USER')
        api.logout_native({to: '/'})
    }
}
